<template>
  <div class="SPAInput-container" :class="{ 'is-invalid': props.hasError }">
    <MDBInput
      inputGroup
      class="rounded"
      aria-describedby="caret-addon"
      v-bind="$attrs"
    >
      <span
        v-if="!hasNoArrow"
        class="input-group-text border-0 caret"
        id="caret-addon"
        @click.prevent="handleClick"
      >
        <span class="SproutIcon SproutIcon-caret-right-regular caret"></span>
      </span>
    </MDBInput>
    <span class="is-invalid error-message" v-if="props.hasError">{{
      props.errorMessage
    }}</span>
  </div>
</template>

<script>
import { MDBInput } from 'mdb-vue-ui-kit';

export default {
  components: {
    MDBInput,
  },
  props: {
    errorMessage: {
      type: String,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    hasNoArrow: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clickAddon'],
  setup(props, { emit }) {
    const handleClick = () => {
      emit('clickAddon');
    };
    return {
      handleClick,
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
.SPAInput-container {
  height: min-content;
  cursor: pointer;

  :deep(.form-outline.input-group) {
    .form-control {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 26px;
      padding-left: 8px !important;

      &[data-has-value='true'] {
        margin-top: unset;
      }
    }

    .form-control[readonly] {
      background-color: transparent;
    }

    .form-control ~ .form-label {
      color: $neutral-500;
    }

    .form-control ~ .form-notch div {
      border-color: $neutral-50;
    }

    .form-control:focus ~ .form-notch .form-notch-leading {
      border-top-color: $green-300;
      border-bottom-color: $green-300;
      border-left-color: $green-300;
    }

    .form-control:focus ~ .form-notch .form-notch-middle {
      border-color: $green-300;
    }

    .form-control:focus ~ .form-notch .form-notch-trailing {
      border-top-color: $green-300;
      border-bottom-color: $green-300;
      border-right-color: $green-300;
    }

    .form-control:focus ~ .form-label {
      margin-top: unset;
      color: $green-300;
    }
  }

  .form-control:focus ~ .form-label &.is-invalid {
    :deep(input.form-control) {
      margin-bottom: 0;

      & ~ .form-label {
        color: $red-300 !important;
      }

      & ~ .form-notch .form-notch-leading,
      & ~ .form-notch .form-notch-middle,
      & ~ .form-notch .form-notch-trailing {
        border-color: $red-300;
      }

      ~ button .far {
        color: $red-300;
      }
    }
    .error-message {
      line-height: 16px;
      font-size: 12px;
      color: $red-300;
    }
  }

  .caret {
    position: absolute;
    z-index: 999;
    left: calc(100% - 25px);
  }
}
</style>
